module.exports = __webpack_public_path__ + "static/img/zhgggg.1dbf65d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhgggg.jpg
// module id = KLGl
// module chunks = 0